import React from 'react'
import { BeakerIcon, CloudIcon } from '@heroicons/react/24/outline'
import { getMyMeetingsMode, isMyMeetingsMockMode } from '../../services/integrations/mymeetings/config'

export const MyMeetingsModeIndicator: React.FC = () => {
  const isMock = isMyMeetingsMockMode()
  
  return (
    <div className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${
      isMock 
        ? 'bg-yellow-100 text-yellow-800 border border-yellow-200' 
        : 'bg-green-100 text-green-800 border border-green-200'
    }`}>
      {isMock ? (
        <>
          <BeakerIcon className="h-3 w-3 mr-1" />
          Mock Mode
        </>
      ) : (
        <>
          <CloudIcon className="h-3 w-3 mr-1" />
          Live Mode
        </>
      )}
    </div>
  )
}

export const MyMeetingsModeMessage: React.FC = () => {
  if (!isMyMeetingsMockMode()) return null
  
  return (
    <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
      <div className="flex">
        <BeakerIcon className="h-5 w-5 text-yellow-400 mt-0.5" />
        <div className="ml-3">
          <h3 className="text-sm font-medium text-yellow-800">
            MyMeetings Mock Mode Active
          </h3>
          <p className="mt-1 text-sm text-yellow-700">
            The integration is running in mock mode with simulated data. 
            This allows you to test the integration flow before MyMeetings is deployed.
            All data shown is for demonstration purposes only.
          </p>
          <p className="mt-2 text-xs text-yellow-600">
            To switch to live mode, set <code className="bg-yellow-100 px-1 py-0.5 rounded">VITE_MYMEETINGS_API_URL</code> in your environment.
          </p>
        </div>
      </div>
    </div>
  )
}